<script lang="ts">
    import { onMount } from 'svelte';
    import { theme } from '../../../services/stores/theme-store.js';

    onMount(async () => {
    });
</script>

<div class="oh-user home">
    <div class="flex flex-col items-left">
        <div class="self-center text-center flex flex-col items-center">
            <img src="/assets/images/islr_program_{$theme}.png" alt="iSLR Logo" class="w-20">
            <h1>Welcome to OPEN Health’s iSLR platform</h1>
        </div>
        <p>OPEN Health’s iSLR platform supports customer iSLR programs by enabling streamlined, AI-powered access to insights from literature reviews.</p>
        <h2 class="self-center">Key capabilities</h2>
        <h3>For customers:</h3>
        <p class="welcome-text">Customers are can query therapeutic areas, projects, and documents through chat, a conversational AI feature designed to surface relevant insights from literature reviews. In addition, customers can browse projects, view associated files, and explore literature using AI-enhanced faceted search. They can access structured project documents, including protocols and reports, and select and download specific documents for offline use.</p>
        <br />
        <h3>For OPEN Health users:</h3>
        <p class="welcome-text">OPEN Health users can query therapeutic areas, projects, and documents through chat, enabling efficient support of customer engagements. They can also service customer accounts, manage projects, and update content configurations. Additionally, users can upload and manage project documents and leverage AI-enabled search, with content categorized and enriched using AI-generated facets to support filtering and discovery.</p>
    </div>
    <div class="flex flex-row align-left">
        <p class="team mt-4">- The OPEN Health Team</p>
    </div>
</div>
